import {
  RewardListPageKey,
  RewardModalKey,
  RewardSellingModalKey,
  StatusTextKey,
  VoucherCodeSetupPageKey
} from '../../TModules';

export const translations = {
  [RewardListPageKey]: {
    Reward: 'Reward',
    List: 'List',
    All: 'All',
    Draft: 'Draft',
    Pending: 'Pending',
    Scheduled: 'Scheduled',
    Active: 'Active',
    Ended: 'Ended',
    Inactive: 'Inactive',
    TransactionIssued: 'Transaction issued',
    Private: 'Private',
    System: 'System',
    SellingFast: 'Selling fast',
    SoldOut: 'Sold out',
    Subtitle: 'Subtitle',
    Stackable: 'Stackable',

    Name: 'Name',
    Merchant: 'Merchant',
    Status: 'Status',
    Balance: 'Balance',
    RedemptionBalance: 'Redemption Balance',
    RewardRedeemed: 'Redeemed',
    VoidedReward: 'Voided',
    SellingFrom: 'Selling From',
    SellingTo: 'Selling To',
    Actions: 'Actions',
    RequestType: 'Request Type',
    Comments: 'Comments',
    LastUpdated: 'Last Updated',

    CreateNew: 'Create new',
    Edit: 'Edit',
    DownloadCodes: 'Download codes',
    DuplicateReward: 'Duplicate Reward',
    Deactivate: 'Deactivate',
    Activate: 'Activate',
    DownloadDepletedCodes: 'Download Depleted Codes',
    UnassginedVouchers: 'Unassigned Vouchers',
    ReplinishVouchers: 'Replenish Vouchers',
    Deplete: 'Deplete',
    Replinish: 'Replenish',
    AppendBudget: 'Append Budget',
    Approve: 'Approve',
    RequestDeletion: 'Request Deletion',
    PublishNew: 'Publish New',
    Reactivate: 'Reactivate',
    NA: 'N.A',

    Type: 'Type',
    RewardName: 'Reward Name',
    Description: 'Description',
    StepsToRedeem: 'Steps to redeem',
    SellingPeriod: 'Selling Period',
    ActiveAt: 'Active At',
    TermsAndConditions: 'Terms & Conditions',
    RiskDisclaimer: 'Risk Disclaimer',
    BrandName: 'Brand name',
    Brands: 'Brands',
    Tags: 'Tags',
    Categories: 'Categories',
    Labels: 'Labels',
    Catalogues: 'Catalogues',
    UploadedPhotos: 'Uploaded photos',
    UploadedPhoto: 'Uploaded photo',
    UploadMultipleImages: 'Upload multiple images',
    UploadAFile: 'Upload a file',
    WhereCanThisbeRewardDisplayed: 'Where can this reward be displayed',
    RewardCost: 'Reward cost',
    SellingPrice: 'Selling Price',
    CustomFields: 'Custom fields',

    AudienceInfo: 'Audience Info',
    AudienceAttributes: 'Audience attributes',
    AudienceList: 'Audience List',
    NoFiltersSelected: 'No filters selected',
    NoListSelected: 'No list selected',

    RewardsMechanics: 'Rewards Mechanics',
    CodeType: 'Code Type',
    Code: 'Code',
    VoucherCodeType: 'Voucher Code Type',
    RewardIssuanceLimit: 'Reward Issuance Limit',
    TotalRedemptionLimit: 'Total Redemption Limit',
    RedemptionLimitsPerPeriod: 'Redemption Limits Per Period',
    RewardIssuancePerPeriodLimit: 'Reward Issuance Per Period Limit',
    UserLimits: 'User Limits',
    UserLimitsPerPeriod: 'User Limits per period',
    VoucherValidity: 'Voucher Validity',
    RedemptionType: 'Redemption Type',
    GiftingOption: 'Gifting Option',

    Public: 'Public',
    MainBodyText: 'Main body text',
    AddAccordion: 'Add accordion',

    Next: 'Next',
    Cancel: 'Cancel',
    Browse: 'Browse',
    Back: 'Back',
    SaveAsDraft: 'Save as Draft',
    Launch: 'Launch',
    Publish: 'Publish',
    Save: 'Save',
    ImportReward: 'Import Reward',
    PerIssuance: 'Per Issuance',
    ConversionMetric: 'Conversion Metric',
    CostPerIssued: 'Cost Per Issued',
    BudgetAllocation: 'Budget Allocation',
    Inventory: 'Inventory',
    ActivationDate: 'Activation Date',
    StartDate: 'Start Date',
    EndDate: 'End Date',
    OperatingDays: 'Operating Days',
    From: 'From',
    DiscountStartDate: 'Discount Start Date',
    DiscountEndDate: 'Discount End Date',
    ID: 'ID',
    CashValue: 'Cash Value',

    PointsValue: 'Points Value',
    LoyaltyProgram: 'Loyalty Program',
    Identifier: 'Identifier',
    Action: 'Action',
    ThisRewardsIsCurrentlyFREE: 'This reward is currently FREE',
    ReActivateSellingPrice: 'Re-activate a selling price below or add a new one.',
    AddSellingPrice: 'Add Selling Price',
    EditSellingPrice: 'Edit Selling Price',
    HowDoYouValueYourRewards: 'How do you value your rewards?',
    CostPrice: 'Cost Price',
    SocialMedia: 'Social Media',
    Title: 'Title',
    Image: 'Image',
    iOSAppLink: 'iOS app link',
    AndroidAppLink: 'Android app link',
    WebLink: 'Web link',
    AddCustomField: 'Add custom field',
    CustomField: 'Custom field',
    TypeInFieldName: 'Type in field name',
    TypeInFieldValue: 'Type in field value',
    SelectCodeType: 'Select code type',
    TypeOfCode: 'Type of Code',
    GenericCode: 'Generic Code',
    QRCode: 'QR code',
    BarCode: 'Bar Code',
    URL: 'URL',
    SelectFile: 'Select File',
    ChooseFile: 'Choose File',
    DownloadSample: 'Download Sample (Accepted Format: .xlsx/.csv files only)',
    ErrorParsingTheFile: 'Error parsing the file',
    SelectStashReward: 'Select Stash Reward',
    RewardHasToBeLinkedToAStashReward: 'Reward has to be linked to a stash reward',
    InventorySource: 'Inventory Source',
    Limits: 'Limits',
    IssueAMaximumOf: 'Issue a maximum of',
    RewardsPer: 'Rewards per',
    Second: 'Second',
    Minutes: 'Minutes',
    Hours: 'Hours',
    Days: 'Days',
    Weeks: 'Weeks',
    Month: 'Month',
    Months: 'Months',
    Year: 'Year',
    ALifetimeLimitMustBeSet: 'A lifetime limit must be set',
    TheMaximumLimitIs: 'The maximum limit is',
    TheLimitMustBeMoreThan: 'The limit must be more than',
    DisplayEvenWhenIssuanceLimitIsReached: 'Display even when issuance limit is reached',
    RewardRedemptionLimit: 'Reward Redemption Limit',
    LimitRedemptionsTo: 'Limit redemptions to',
    PleaseFillInTheLimitRedemptionToValue: 'Please fill in the limit redemption to value',
    PleaseFillInTheRedemptionIntervalUnits: 'Please fill in the redemption interval units',

    UserLimit: 'User Limit',
    UserLimitPerPeriod: 'User Limit per period',
    DisplayEvenWhenLimitIsReached: 'Display even when limit is reached',
    ValidityPeriod: 'Validity Period',
    AfterDateOfPurchaseDate: 'After date of purchase date',
    SelectType: 'Select Type',
    Period: 'PERIOD',
    IssuanceDate: 'ISSUANCE DATE',
    EndOfMonth: 'END OF MONTH',
    RedemptionOutcomes: 'Redemption Outcomes',
    AddOutcome: 'Add Outcome',
    Online: 'ONLINE',
    Offline: 'OFFLINE',
    MerchantPIN: 'MERCHANT PIN',
    Pin: 'PIN',
    APIRedemption: 'API REDEMPTION',
    SetCountdown: 'Set Countdown',
    SelectGiftingOption: 'Select Gifting Option',
    ScheduleLaunch: 'Schedule Launch',
    MapYourRewardTo: 'Map your reward to',
    Include: 'Include',
    SneakPeek: 'Sneak Peek',
    SelectLoyaltyProgram: 'Please select your loyalty Program',
    PickAudienceList: 'Pick an audience list',
    UploadNewList: 'Upload New List',
    AcceptedFormat: 'Accepted Format: .xlsx/.csv files only',
    AudienceNotInList: 'Audience not in the list?',
    PleaseSelectAMerchant: 'Please select a merchant',
    StartDateEndDateRequired: 'Start date & end date required',
    EndDateCannotBeBeforeStartDate: 'End date cannot be before start date',
    RewardHasToBeLinkedToAnInventoryItem: 'Reward has to be linked to an inventory item',
    BatchNeedsToBeSelected: 'Batch needs to be selected',
    NumberOfVouchersMustBeGreaterOrEqual1: 'Number of vouchers must be greater or equal 1',
    VoucherCodesCannotBeEmpty: 'Voucher codes cannot be empty',
    Batches: 'Batches',
    MerchantName: 'Merchant Name',
    UNASSIGNED_VOUCHER_CODES: 'UNASSIGNED VOUCHER CODES',
    ACTIVE_INVENTORY_BALANCE: 'ACTIVE INVENTORY BALANCE',
    OutOf: 'out of',
    IncludeFromBatch: 'Include from batch',
    VoucherCodes: 'Voucher Codes',
    IncludeAnotherBatch: 'Include Another Batch',
    PrefixForVoucherCode: 'Prefix for Voucher Code',
    LengthOfCode: 'Length of Code',
    CodeFormat: 'Code Format',
    Total: 'Total',
    PossibleTotalPermutations: 'Possible Total Permutations',
    SelectOption: 'Select Option',
    RedemptionTypeEditError: "Sorry, you can't edit Redemption Type of Active Reward.",
    EnterCallToActionURL: 'Enter Call To Action URL',
    APIEndpoint: 'API Endpoint',
    QueryParamsValue: 'Query Params Value',
    BodyParamsValue: 'Body Params Value',
    PleaseSelectRedemptionType: 'Please Select Redemption Type',
    PleaseSelectAnAPI: 'Please select an API',
    Key: 'Key',
    Value: 'Value',
    Prefix: 'Prefix',
    Postfix: 'Postfix',
    isRequired: 'is required',
    IDENTIFIER: 'IDENTIFIER',
    PROGRAM: 'PROGRAM',
    POINTS: 'POINTS',
    PRICE: 'PRICE',
    LISTING: 'LISTING',
    Exclude: 'Exclude',
    SneakPreview: 'Sneak Preview',

    ValidityAtLeastOneHour: 'Validity has to be at least 1 hour',
    ValidFor: 'Valid for',
    GraceTime: 'Grace Time',
    GraceTimeCannotBeNegative: 'Grace time cannot be negative',
    Yes: 'Yes',
    No: 'No',

    RewardInfo: 'Reward Info',
    RewardMechanics: 'Reward Mechanics',
    PendingReward: 'Pending Reward',
    AddComment: 'Add Comment',
    ThisRewardIsPendingApproval:
      'This reward is pending reviews approval. Any comments added will show up here.',
    ViewAndAddComments: 'View and add comments',
    EnterYourCommentHere: 'Enter your comment here',
    ErrorDeletingComment: 'Error deleting comment',
    DeleteComment: 'Delete Comment?',
    CommentDeleted: 'Comment deleted',
    CommentsAdded: 'comments added',
    AreYouSureYouWantToDeleteThisComment: 'Are you sure you want to delete this comment',
    RewardMustHaveAName: 'Reward must have a name',
    AllowedFileTypes: 'Allowed: .jpg, .png, .svg',
    EitherAniOSOrAndroidOrWebLinkIsRequired: 'Either an iOS or Android or Web link is required',
    Delete: 'Delete',
    InsertPhoto: 'Insert Photo',
    SelectImageType: 'Select png, svg, jpeg, or gif images',
    Info: 'Info',
    Audience: 'Audience',
    SelectAudience: 'Select Audience',
    Review: 'Review',
    Mechanics: 'Mechanics',
    RewardDetails: 'Reward Details',
    SelectDate: 'Select date',
    SelectTime: 'Select time',

    PleaseSelectYourBrands: 'Please select your brands',
    PleaseSelectYourTags: 'Please select your tags',
    PleaseSelectYourCategories: 'Please select your categories',
    PleaseSelectYourLabels: 'Please select your labels',
    PleaseSelectYourCatalogues: 'Please select your catalogues',
    PleaseSelectAnOwner: 'Please select an owner',
    TypeInYourRewardNameHere: 'Type in your reward name here',
    TypeInYourSubtitleNameHere: 'Type in your subtitle name here',

    EnglishRewardNameRequired: 'English reward name is required',
    RewardNameRequired: 'Reward name is required',
    StartDateRequired: 'Start date is required',
    RewardOwnerRequired: 'Reward Owner is required',
    UploadedImagesShouldBeSetAsSection: 'Uploaded images should be set as a section',
    DiscountStartDateCannotBeBlank: 'Discount start date cannot be blank',
    DiscountEndDateCannotBeBlank: 'Discount end date cannot be blank',
    DiscountEndDateCannotBeBeforeDiscountStartDate:
      'Discount end date cannot be before discount start date',
    RewardPartnerRequired: 'Reward partner is required',
    ValidityPeriodMustExtendPastSellingPeriod:
      'The validity period must extend past the selling period.',
    RewardLimitFieldShouldBePositive: 'Reward Limit Field should be positive',
    RewardLimitPerPeriodFieldShouldBePositive: 'Reward Limit per period Field should be positive',
    RewardLimitPerPeriodUnitsRequired: 'Reward Limit per period Units is required',
    RewardLimitPerPeriodUnitsShouldBeMoreThanZero:
      'Reward Limit per period Units should be more than zero',
    RewardLimitPerPeriodFieldRequired: 'Reward Limit per period Field is required',
    RewardLimitPerPeriodFieldShouldBeMoreThanZero:
      'Reward Limit per period Field should be more than zero',
    UserLimitFieldShouldBePositive: 'User Limit Field should be positive',
    UserLimitPerPeriodFieldShouldBePositive: 'User Limit per period Field should be positive',
    UserLimitPerPeriodUnitsRequired: 'User Limit per period Units is required',
    UserLimitPerPeriodUnitsShouldBeMoreThanZero:
      'User Limit per period Units should be more than zero',
    UserLimitPerPeriodFieldRequired: 'User Limit per period Field is required',
    RedemptionIntervalUnitsOrLimitRedemptionToValueShouldBeMoreThanZero:
      'Redemption interval units or limit redemption to value should be more than zero',
    ActivationStartDate: 'Activation Start Date',
    SetActivationStartDate: 'Set Activation Start date',
    ApproveReward: 'Approve Reward',
    SubmitDeletionRequest: 'Submit deletion request',
    AreYouSureYouWantToApproveThisReward: 'Are you sure you want to approve this reward?',
    ThisActionCannotBeUndone: 'This action cannot be undone',
    ThisRewardIsPendingApprovalAreYouSureYouWantToDeleteIt:
      'This reward is pending approval. Are you sure you want to delete it?',
    OnceTheDeletionIsApprovedThisRewardWillNotBeAvailableAndYouWillNeedToCreateItAgain:
      'Once the deletion is approved, this reward will not be available and you will need to create it again.',
    SetAs: 'Set as',

    PERIOD: 'PERIOD',
    To: 'to',
    ISSUANCE_DATE: 'ISSUANCE DATE',
    END_OF_MONTH: 'END OF MONTH',
    ONLINE: 'ONLINE',
    OFFLINE: 'OFFLINE',
    PIN: 'PIN',
    Every: 'Every',
    Day: 'Day',
    OpenTimeIsRequired: 'Open time is required',
    CloseTimeIsRequired: 'Close time is required',
    CloseTimeCannotBeBeforeOrSameAsOpenTime: 'Close time cannot be before or same as open time',

    RewardOutcomesTable: {
      OutcomeType: 'Outcome Type',
      Value: 'Value',
      LoyaltyProgram: 'Loyalty Program',
      Action: 'Action',
      SetOutcomeValue: 'Set Outcome Value',
      Delete: 'Delete'
    }
  },
  [VoucherCodeSetupPageKey]: {
    NoCode: 'No Code',
    Single: 'Single',
    SystemGenerated: 'System Generated',
    UserUpload: 'User Upload',
    Inventory: 'Inventory',
    Stash: 'Stash',
    VoucherCodeSetup: 'Voucher Code Setup',
    SelectCodeType: 'Select Code Type',
    None: 'None'
  },
  [RewardSellingModalKey]: {
    SelectLoyaltyProgram: 'Select loyalty program',
    SelectTier: 'Select tier',
    Cash: 'Cash',
    PointsRegularPrice: 'Points (regular price)',
    PointsDiscountPrice: 'Points (discount price)',
    egHundred: 'e.g. 100',
    Optional: 'Optional',
    SelectGLAccount: 'Select GL Account',
    GLAccountType: 'GL Account Type',
    GLAccountName: 'GL Account Name ',
    EitherPriceOrPointsIsRequired: 'Either price or points is required',
    DiscountPriceCannotBeMoreThanRegularPrice:
      'Discount price cannot be more than the regular price',
    DiscountPriceShouldBeAtLeast: 'Discount price should be at least 1',
    Issue: 'Issue',
    Value: 'Value',
    Points: 'Points'
  },
  [StatusTextKey]: {
    active: 'Active',
    inactive: 'Inactive',
    draft: 'Draft',
    processing: 'Processing',
    pending: 'Pending',
    approved: 'Approved',
    scheduled: 'Scheduled',
    redeemed: 'Redeemed',
    ended: 'Ended',
    failed: 'Failed',
    fail: 'Fail',
    expired: 'Expired',
    public: 'Public',
    completed: 'Completed',
    success: 'Success',
    timeout: 'Timeout',
    system: 'System',
    CreatingReward: 'Creating reward...',
    RewardSubmittedForApproval: 'Reward submitted for approval',
    FailedToCreateReward: 'Failed to Create Reward !',
    RewardApproval: 'Reward Approval...',
    ApprovalSuccess: 'Approval Success...',
    FailedToApprove: 'Failed to Approve!',
    DeactivationRequestSubmittedForApproval: 'Deactivation Request Submitted For Approval!',
    DeactivationSuccess: 'Deactivation Success...',
    FailedToDeactivate: 'Failed to Deactivate!',
    RewardDeactivation: 'Reward Deactivation...',
    RewardReactivation: 'Reward Reactivation...',
    ReactivationSuccess: 'Reactivation Success...',
    ReactivationRequestSubmittedForApproval: 'Reactivation Request Submitted For Approval!',
    FailedToReactivate: 'Reactivation Failed!',
    Processing: 'Processing...',
    FailedToUpdateReward: 'Failed to Updating Reward !',
    ErrorLoadingRewards: 'Error loading rewards!',
    ErrorLoadingTags: 'Error loading tags!',
    ErrorLoadingBrands: 'Error loading brands!',
    ErrorLoadingAudiences: 'Error loading audience list!',
    SubmittingData: 'Submitting data...',
    FileUploadSuccess: 'File Upload Success',
    DuplicatingReward: 'Duplicating reward...',
    FailedToDuplicate: 'Failed to Duplicate!',
    FailedToLoadData: 'Failed to Load Data!',
    CouldNotRetrieveRewards: 'Could not retrieve rewards!',
    ErrorObtainingPartnerDetails: 'Error obtaining partner details !',
    ErrorLoadingMerchants: 'Error loading merchants!',
    ErrorLoadingLoyaltyList: 'Error loading loyalty list!'
  },

  [RewardModalKey]: {
    CurrentTotalRewardLimit: 'Current Total Reward Limit',
    ReplenishVoucherCodesAndLimits: 'Replenish Voucher Codes and Limits',
    DepleteVoucherCodesAndLimits: 'Deplete Voucher Codes and Limits',
    Replenish: 'Replenish',
    Deplete: 'Deplete',
    Depleting: 'Depleting',
    Replenishing: 'Replenishing',
    UploadNewVoucherCodes: 'Upload New Voucher Codes',
    ClickOrDragFileToUpload: 'Click or drag file to this area to upload',
    DepleteMustBeGreaterThanZero: 'Deplete must be greater than zero.',
    DepletingReplenished: 'Depleting Replenished',
    SuccessfullyReplenished: 'Successfully Replenished',
    ThereAreDuplicatedCodes: 'There are {{count}} duplicated codes.',
    DownloadDuplicatedCodes: 'Download Duplicated Codes',
    RewardLimitStatus: '{{value}} of {{total}} reward limit',
    ThereAreDepletedCodes: 'There are {{depleted_count}} depleted codes.',
    DownloadDepletedCodes: 'Download Depleted Codes',
    DownloadLogFile: 'Download Log File',
    YouHaveDuplicateVoucherCodes:
      'You have {{duplicates_count}} duplicate voucher codes. Please check your file and upload again.'
  }
};
